import type { FC } from 'react';
import type { Dayjs } from 'dayjs';
import { Segmented, Button } from 'antd';
import { ChevronLeft, ChevronRight, Plus } from 'lucide-react';

interface CalendarToolbarProps {
  currentMonth: Dayjs;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onAdd: () => void;
  viewMode: 'month' | 'week';
  onViewModeChange: (mode: 'month' | 'week') => void;
}

const CalendarToolbar: FC<CalendarToolbarProps> = ({
  currentMonth,
  onPrev,
  onNext,
  onToday,
  onAdd,
  viewMode,
  onViewModeChange,
}) => {
  const monthLabel = currentMonth.format('MMMM YYYY');

  return (
    <div className="fc-card flex flex-wrap items-center justify-between gap-3 p-3">
      {/* Navigation mois */}
      <div className="flex items-center gap-2">
        <button
          onClick={onPrev}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-700 transition-colors"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>

        <span className="min-w-[160px] text-center text-sm font-semibold capitalize text-slate-900 dark:text-white">
          {monthLabel}
        </span>

        <button
          onClick={onNext}
          className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-700 transition-colors"
        >
          <ChevronRight className="h-4 w-4" />
        </button>

        <Button size="small" onClick={onToday}>
          Aujourd'hui
        </Button>
      </div>

      {/* Toggle vue + Bouton Ajouter */}
      <div className="flex items-center gap-3">
        <Segmented
          size="small"
          value={viewMode}
          options={[
            { label: 'Mois', value: 'month' },
            { label: 'Semaine', value: 'week' },
          ]}
          onChange={(val) => onViewModeChange(val as 'month' | 'week')}
        />

        <Button type="primary" size="small" icon={<Plus className="h-3.5 w-3.5" />} onClick={onAdd}>
          Ajouter
        </Button>
      </div>
    </div>
  );
};

export default CalendarToolbar;
